/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedupe lines of text`)
};

const es_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desduplicar líneas de texto`)
};

const de_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textzeilen bereinigen`)
};

const nl_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedupliceer regels tekst`)
};

const fr_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les doublons de texte`)
};

const it_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deduplicare righe di testo`)
};

const pt_br2_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remova linhas duplicadas de texto`)
};

const pt_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar duplicatas de linhas de texto`)
};

const ja_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト行の重複を削除`)
};

const zh_rd_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本行去重`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_nav_main_desc", locale)
	if (locale === "en") return en_rd_nav_main_desc(inputs)
	if (locale === "es") return es_rd_nav_main_desc(inputs)
	if (locale === "de") return de_rd_nav_main_desc(inputs)
	if (locale === "nl") return nl_rd_nav_main_desc(inputs)
	if (locale === "fr") return fr_rd_nav_main_desc(inputs)
	if (locale === "it") return it_rd_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_rd_nav_main_desc(inputs)
	if (locale === "pt") return pt_rd_nav_main_desc(inputs)
	if (locale === "ja") return ja_rd_nav_main_desc(inputs)
	return zh_rd_nav_main_desc(inputs)
};